import * as React from 'react';
/**
 *
 * Original name: cloud
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=29923%3A6817
 *
 */
export const CloudPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M54 21c0-3.55-1.035-6.613-3.21-8.79C48.612 10.035 45.55 9 42 9v4c2.784 0 4.72.799 5.96 2.04C49.202 16.28 50 18.215 50 21h4Z", fill: "currentColor" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M44 26c7.6 0 12 4.4 12 12 0 7.5-4.3 11.9-11.7 12H19.8C12.3 49.9 8 45.6 8 38s4.4-12 12-12c0-7.6 4.4-12 12-12s12 4.4 12 12ZM12 38c0 5.5 2.5 8 8 8h24c5.5 0 8-2.5 8-8s-2.5-8-8-8h-4v-4c0-5.5-2.5-8-8-8s-8 2.5-8 8v4h-4c-5.5 0-8 2.5-8 8Z", fill: "currentColor" })));
